import {Link} from 'react-router-dom';

// Keep the action readable while linking the capability to its usage guidance.
export default function PlatformCapability({name, doc, kind = 'tool'}) {
  return <Link className="platform-capability" to={`/docs/${doc}`}>
    {kind === 'feature' ? name : <code>{name}</code>}
  </Link>;
}
